<div class="container-fluid">
  <div class="row">
    <div class="col-full-12">
      <div
        class="sticky-content-container"
        baseIsSticky
      >
        <base-go-back-teaser
          [qualificationName]="inquiry.mainQualification?.name"
          [dateFrom]="inquiry.dateFrom"
          [dateTo]="inquiry.dateTo"
        ></base-go-back-teaser>
        <base-customer-inquiry-offers-list-filters
          [branches]="branches"
          [qualifications]="mainQualifications"
          [filtersForm]="filtersForm"
        ></base-customer-inquiry-offers-list-filters>
        <div class="d-flex justify-content-between mt-3 me-3">
          <base-search
            class="me-3"
            placeholder="search.forCandidates"
            [value]="activatedRoute.snapshot.queryParams.search"
            [useEnterEvent]="true"
            (query)="onSearchChange($event)"
          ></base-search>
          <div class="d-flex">
            <div>
              <ng-container [ngTemplateOutlet]="footerTemplate"></ng-container>
            </div>
            <base-button
              label="inquiry.showInquiryInfo"
              color="primary"
              class="d-flex align-items-center mt-2 mt-sm-0 gap-2 ms-xs-4 ms-sm-0 ms-md-4"
              (btnClick)="toggleSidebar()"
            ></base-button>
          </div>
        </div>
      </div>
      <div class="row">
        <base-infinite-scroll
          *ngIf="offers.length > 0"
          (scrollDownEvent)="onScrollDown()"
        >
          <div class="listview container-fluid">
            <div class="listview-header">
              <div class="row">
                <div class="col-3">
                  <base-sortable-headline-item
                    orderKey="profileLastName"
                    [label]="('name' | translate) + ' | ' + ('readiness' | translate)"
                  ></base-sortable-headline-item>
                </div>
                <div class="col-3">
                  <div baseTruncate>{{ 'provider' | translate }}</div>
                </div>
                <div class="col-2">
                  <base-sortable-headline-item
                    label="qualifications.singular"
                    orderKey="qualificationName"
                  ></base-sortable-headline-item>
                </div>
                <div class="col-1">
                  <base-sortable-headline-item
                    label="price.singular"
                    orderKey="price"
                  ></base-sortable-headline-item>
                </div>
                <div class="col-1">
                  <div baseTruncate>{{ 'shiftStatus.legend.available' | translate }}</div>
                </div>
                <div class="col-2"></div>
              </div>
            </div>

            <div
              *ngFor="let offer of filteredOffers"
              class="listview-item"
              [ngClass]="{
                'offer-sent': offer.data.status === offerStatuses.open,
                'offer-declined': offer.data.status === offerStatuses.declined,
                'offer-confirmed': offer.data.status === offerStatuses.confirmed,
                'offer-needs-confirmation':
                  offer.data.status === offerStatuses.needsConfirmation ||
                  offer.data.status === offerStatuses.needsUpdate,
                'offer-preselected':
                  isOfferPreselectionAllowed &&
                  offer.data.status === offerStatuses.open &&
                  offer.data.preselected &&
                  !offer.data.workCouncilStatus,
                'offer-work-council-approved':
                  offer.data.workCouncilStatus === offerWorkCouncilStatuses.APPROVED ||
                  offer.data.workCouncilStatus === offerWorkCouncilStatuses.AUTO_APPROVED,
                'offer-work-council-disapproved': offer.data.workCouncilStatus === offerWorkCouncilStatuses.DISAPPROVED
              }"
            >
              <div class="row">
                <div
                  baseTruncate
                  class="col-3 listview-highlight-text d-flex gap-2 align-items-center"
                >
                  <base-avatar
                    [image]="offer.data.anonymous ? '' : offer.data.profile.avatar || ''"
                    [size]="avatarSize.medium"
                    (click)="openOfferInfoModal(offer.data, false, $event)"
                  ></base-avatar>
                  <div class="d-flex flex-column">
                    <div
                      class="d-block"
                      (click)="openOfferInfoModal(offer.data, false, $event)"
                    >
                      <ng-container *ngIf="offer.data.anonymous && offer.data.status !== offerStatuses.confirmed">
                        <p
                          baseTruncate
                          class="m-0 fw-bold"
                        >
                          {{ offer.data.profile.firstName | baseAnonymizeFullName: offer.data.profile.lastName }}
                        </p>
                        <p
                          baseTruncate
                          class="m-0 fw-bold text-dark-gray fa-0-75x"
                        >
                          {{ 'inquiry.anonymizedOffer' | translate }}
                        </p>
                      </ng-container>
                      <ng-container *ngIf="!offer.data.anonymous || offer.data.status === offerStatuses.confirmed">
                        <p
                          baseTruncate
                          class="m-0 fw-bold"
                        >
                          {{ offer.data.profile.firstName }} {{ offer.data.profile.lastName }}
                        </p>
                      </ng-container>
                    </div>
                    <base-candidate-shifts-availability
                      class="mt-2"
                      [candidateAvailability]="offer.data.profile.candidateAvailability"
                    ></base-candidate-shifts-availability>
                    <base-candidate-weekdays-availability
                      [candidateAvailability]="offer.data.profile.candidateAvailability"
                    ></base-candidate-weekdays-availability>
                  </div>
                </div>
                <div
                  baseTruncate
                  class="col-3 d-flex align-items-center gap-2"
                >
                  <i
                    class="fa-solid"
                    [ngClass]="{
                      'fa-circle-a a': offer.data.pspBranch.deliveryType === 'a',
                      'fa-circle-b b': offer.data.pspBranch.deliveryType === 'b',
                      'fa-circle-c c': offer.data.pspBranch.deliveryType === 'c',
                      'fa-circle-xmark': !offer.data.pspBranch.deliveryType
                    }"
                    [ngbTooltip]="
                      ('administration.timeToWait.timeToWaitCategory' | translate) +
                      (offer.data.pspBranch.deliveryType === 'a'
                        ? ' A'
                        : offer.data.pspBranch.deliveryType === 'b'
                        ? ' B'
                        : ' C')
                    "
                  ></i>
                  <span>
                    {{ offer.data.psp.name }}<br />
                    {{ offer.data.pspBranch.name }}
                  </span>
                </div>
                <div
                  baseTruncate
                  class="col-2"
                >
                  <span class="text-dark-green">{{ offer.data.mainQualification.name | baseIsEmpty }}</span>
                  <ng-container *ngIf="offer.data.profile.qualifications?.length">
                    <br />
                    <span class="text-dark-gray"
                      >{{ offer.data.profile.qualifications[0].name | baseIsEmpty }}<br />
                      <ng-container *ngIf="offer.data.profile.qualifications.length > 1">
                        + {{ offer.data.profile.qualifications.length - 1 }} {{ 'additional' | translate }}
                      </ng-container>
                    </span>
                  </ng-container>
                </div>
                <div
                  baseTruncate
                  class="col-1"
                >
                  {{ offer.data.hourlyRate | baseFormatDecimal | baseIsEmpty }} €
                </div>
                <div
                  baseTruncate
                  class="col-1"
                >
                  {{ offer.data.positions[0]?.date | baseFormatDate }} -<br />
                  {{ offer.data.positions[offer.data.positions.length - 1]?.date | baseFormatDate }}
                </div>
                <div class="col-2">
                  <div class="d-flex flex-nowrap gap-2 align-items-center justify-content-between">
                    <div class="d-flex flex-wrap gap-2 align-items-center">
                      <i
                        class="fa-solid pointer"
                        (click)="openRequirementsModal($event, offer.data.profile)"
                        [ngbTooltip]="
                          allRequirementsFulfilled(offer.data.profile.requirements, inquiry.requirements)
                            ? ('inquiry.allRequirementsFulfilled' | translate)
                            : ('inquiry.notAllRequirementsFulfilled' | translate)
                        "
                        [ngClass]="
                          allRequirementsFulfilled(offer.data.profile.requirements, inquiry.requirements)
                            ? 'fa-check text-primary'
                            : 'fa-xmark text-light-gray'
                        "
                      ></i>
                      <i
                        class="fa-solid fa-calendar text-primary"
                        [ngbTooltip]="'inquiry.offeredDays' | translate"
                        (click)="openPositionsDatePickerModal($event, offer.data)"
                      ></i>
                      <i
                        (click)="openNoteFromProviderModal($event, offer.data)"
                        class="mt-1 mb-0 pointer"
                        [ngClass]="
                          offer.data.note
                            ? 'fa-solid fa-message text-primary'
                            : 'fa-regular fa-message-slash text-light-gray'
                        "
                        [ngbTooltip]="
                          offer.data.note
                            ? ('tooltip.remarkFromProvider' | translate)
                            : ('tooltip.noRemarksFromProvider' | translate)
                        "
                      ></i>
                      <i
                        class="fa-solid mt-1 mb-0 fa-building"
                        [ngClass]="offer.data.profile?.experience ? 'text-primary' : 'text-light-gray'"
                        [ngbTooltip]="
                          offer.data.profile?.experience
                            ? ('tooltip.experienceInCompany' | translate)
                            : ('tooltip.noExperienceInCompany' | translate)
                        "
                      ></i>
                      <span class="star">
                        <i
                          class="fa-fw fa-star"
                          [ngClass]="offer.data.profile?.ratingCount ? 'fas text-warning' : 'far text-light-gray'"
                          [ngbTooltip]="starTooltip"
                        ></i>
                        <ng-template #starTooltip>
                          <base-rating
                            *ngIf="offer.data.profile?.ratingCount > 0"
                            [hideCount]="true"
                            [currentRate]="offer.data.profile?.averageRating"
                            starIconClasses="fs-7"
                          ></base-rating>
                          <div *ngIf="!offer.data.profile?.ratingCount">
                            {{ 'inquiry.noRatingMessage' | translate }}
                          </div>
                        </ng-template>
                      </span>
                      <img
                        [src]="
                          offer.data.industrySurcharges
                            ? 'assets-global/images/industry-surcharges-growth.svg'
                            : 'assets-global/images/industry-surcharges-disabled.svg'
                        "
                        [ngClass]="offer.data.industrySurcharges ? 'pointer' : 'no-pointer'"
                        (click)="openIndustrySurchargeModal($event, offer.data.industrySurcharges)"
                        [ngbTooltip]="
                          offer.data.industrySurcharges
                            ? ('tooltip.industrySurcharges' | translate)
                            : ('tooltip.noIndustrySurcharges' | translate)
                        "
                        alt="Industry Surcharges List"
                      />
                      <base-izs-rating
                        [color]="offer.data.pspBranch.izsStatus"
                        [isSmallLogo]="true"
                        (click)="openIzsInfoModal($event, offer.data.pspBranch)"
                      ></base-izs-rating>
                    </div>

                    <base-customer-unlimited-offer-actions
                      [offer]="offer"
                      [offerAction]="offerAction"
                      [locationWorkCouncilSettings]="locationWorkCouncilSettings"
                      (openOfferInfoModal)="openOfferInfoModal($event, true)"
                    ></base-customer-unlimited-offer-actions>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </base-infinite-scroll>
        <base-empty-list-row
          *ngIf="!offers.length"
          class="mt-3"
          message="dashboardInfo.noOffers"
        ></base-empty-list-row>
      </div>
    </div>
    <div class="right-content">
      <base-inquiry-details-sidebar
        [inquiry]="inquiry"
        [inquiryId]="copiedInquiry.id"
        [offersCount]="offersCount"
        [shiftTimes]="shiftTimes"
        [isSidebarVisible]="isSidebarVisible"
        (hideSidebar)="toggleSidebar()"
        [widgetsTemplate]="footerTemplate"
      ></base-inquiry-details-sidebar>
    </div>
  </div>
</div>

<ng-template #footerTemplate>
  <div
    class="d-flex align-items-center right-content h-100"
    [ngClass]="inquiry.status !== baseInquiryStatus.closed ? 'justify-content-end' : 'justify-content-between'"
  >
    <base-action-dropdown
      *ngIf="inquiry.status !== baseInquiryStatus.closed && canPublishInquiry"
      class="mw-100 me-3"
      [items]="
        inquiry.status === baseInquiryStatus.unpublished
          ? ['action.close', 'action.publish', 'action.edit']
          : ['action.close']
      "
      [label]="'states.' + baseInquiryStatus[inquiry.status]"
      [color]="inquiry.status === baseInquiryStatus.unpublished ? 'outline-danger' : 'outline-success'"
      (listItemClicked)="handleClick($event)"
    >
    </base-action-dropdown>
    <div
      class="reason-info"
      *ngIf="inquiry.status === this.baseInquiryStatus.closed"
    >
      <p
        baseDynamicFontSize="100"
        class="mb-0 me-3 text-center"
        *ngIf="inquiry?.closedBy; else closedBySystemMessage"
      >
        {{ 'operations.reason' | translate }}: {{ inquiry?.closedNote | baseIsEmpty }}
      </p>
      <ng-template #closedBySystemMessage>
        <p class="mb-0 me-3 text-center">{{ 'inquiry.closedBySystem' | translate }}</p>
      </ng-template>
    </div>
    <base-button
      [ngbTooltip]="'inquiry.createByCopy' | translate"
      color="dark"
      icon="fa-solid fa-copy"
      [iconSize]="buttonSizes.md"
      stateClass="pe-1"
      (btnClick)="copyInquiry(inquiry)"
    >
    </base-button>
  </div>
</ng-template>

<ng-template #requirementsPopup>
  <base-inquiry-requirements-modal
    [inquiryRequirements]="baseInquiryService.ungroupRequirements(inquiry.requirements)"
    [candidateRequirements]="offerProfileRequirements"
  ></base-inquiry-requirements-modal>
</ng-template>

<ng-template #offerInfoPopup>
  <base-customer-offer-info-modal
    [offer]="currentOfferInfo"
    [inquiry]="inquiry"
    [assignment]="assignmentInfo"
    [assignmentContractSigningStatus]="validContract?.signingStatus"
    [inquiryRequirementCategories]="inquiry.requirements || []"
    [modalRef]="modalRef"
    [openOperationInfo]="toOperationTab"
    [isAssignmentsAdmin]="hasAdminAssignmentsPermission"
    (acceptOrRejectOffer)="acceptOrRejectOfferFromInfoModal($event)"
  ></base-customer-offer-info-modal>
</ng-template>

<ng-template #staffRequest>
  <base-customer-staff-request-modal
    [modalRef]="modalRef"
    [inquiry]="copiedInquiry"
    [isInquiryDefaultFilter]="true"
  ></base-customer-staff-request-modal>
</ng-template>

<ng-template #closeInquiryModal>
  <base-customer-close-inquiry-form [modalRef]="onInquiryCloseModalRef"></base-customer-close-inquiry-form>
</ng-template>

<ng-template #rejectOfferTemplate>
  <div
    class="d-flex flex-column gap-4"
    [formGroup]="rejectOfferForm"
    [ngClass]="{ 'was-validated': isRejectFormSubmitted }"
  >
    <span [innerHTML]="'inquiry.rejectOfferConfirmation' | translate: { fullName: profileName }"></span>
    <base-dropdown
      [items]="modalOptions"
      formControlName="decliningCategory"
      [translateItems]="true"
      [searchable]="false"
      [requiredLabel]="true"
      bindOptionLabel="label"
      placeholder="inquiry.rejectReasonPlaceholder"
      baseFieldValidationArgs="rejectReasonRequired"
    >
    </base-dropdown>
    <base-textarea
      formControlName="decliningNote"
      placeholder="inquiry.rejectMessagePlaceholder"
      [isInvalid]="!!rejectOfferForm.get('decliningNote')?.errors"
      [errorMessage]="rejectOfferForm.get('decliningNote')?.errors | baseFieldValidation"
    ></base-textarea>
  </div>
</ng-template>

<ng-template #datePickerModal>
  <base-date-picker-modal [currentOffer]="currentOfferInfo"></base-date-picker-modal>
</ng-template>

<ng-template #industrySurchargesModal>
  <base-industry-surcharges
    [surcharges]="offers[clickedIndustrySurchargeIndex].data.industrySurcharges"
    [showCategoryAndMethod]="true"
  ></base-industry-surcharges>
</ng-template>
